import * as EventKit from 'event-kit';
export var IDisposable;
(function (IDisposable) {
    function is(arg) {
        return !!arg && 'dispose' in arg;
    }
    IDisposable.is = is;
})(IDisposable || (IDisposable = {}));
export class Disposable {
    constructor(action) {
        if (IDisposable.is(action)) {
            this._disposable = action;
        }
        else
            this._disposable = new EventKit.Disposable(action);
    }
    dispose() {
        this._disposable.dispose();
    }
}
//# sourceMappingURL=disposable.js.map